import React, {FunctionComponent} from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import { ContactPhone } from '@material-ui/icons';

const styles = (theme: any) => ({
  container: { 
    backgroundColor: 'white',
    width:'80%',   
    padding:'2%',
  },
  button:{
      minWidth:'60px' ,
      minWheight:'40px',
      maxWidth:'60px' ,
      maxHeight:'40px',
      borderRadius:'5px',
      color: 'white',
      backgroundColor: 'red',   
      border: 'none',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'black',
   },               
  }
});

interface Props { 
  onChange: any
  value: string
  classes?: any
  onSubmit: any
}

const FormPhone: FunctionComponent<Props> = ({ onChange, classes, value, onSubmit }) => {
 
 
  return (
    <div className={classes.container}>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <ContactPhone />
          </Grid>
          <Grid item xs={11} direction="row">
            <Box display="flex"
            flexDirection="row">
            <TextField fullWidth value={value} onChange={onChange} id="input-with-icon" label="Insira o seu telefone" />
            <button onClick={onSubmit} className={classes.button}>Enviar</button>
            </Box>
          </Grid>     
        </Grid>
      </div>
    </div>
  );
}


export default withStyles(styles)(FormPhone);